// extracted by mini-css-extract-plugin
module.exports = {"modal":"KhwvP","modalHeader":"BAUNU","title":"c9eM9","closeBtn":"IlJ5j","closeIcon":"QtsDw","show":"k30e2","overlay":"K8ZUQ"};